// src/api/users.ts
import type { AuthContextProps } from 'react-oidc-context';
import { getOrCreateClientId } from './clientIdHelper';
import api from '../api';

const ACCOUNT_ID_KEY = 'flashroom-accountId';

export async function getOrCreateCurrentUser(
    auth: AuthContextProps,
    accessToken = auth.user?.access_token
) {
    const token = accessToken;

    if (!token) {
        throw new Error('Missing Cognito access token');
    }

    const response = await api.get('/users/me', {
        headers: {
            Authorization: `Bearer ${token}`,
            'X-Client-Id': getOrCreateClientId(),
            'X-Account-Id': localStorage.getItem(ACCOUNT_ID_KEY) || '',
        },
    });

    if (!response.data) {
        throw new Error('No user data returned from server');
    }

    return response.data;
}
